/**
 * Every fixture timestamp is relative to page load, so the demo never reads as
 * abandoned ("last lead: 8 months ago") no matter when someone opens it.
 */

const BOOT = Date.now();

export function hoursAgo(hours: number): string {
  return new Date(BOOT - hours * 3_600_000).toISOString();
}

export function daysAgo(days: number): string {
  return new Date(BOOT - days * 86_400_000).toISOString();
}

export function daysAhead(days: number): string {
  return new Date(BOOT + days * 86_400_000).toISOString();
}

/** `YYYY-MM-DD` for the day `offset` days from today (negative = past). */
export function dayKey(offset: number): string {
  return new Date(BOOT + offset * 86_400_000).toISOString().slice(0, 10);
}
